import type { SearchableDropdownOption } from "./searchableDropdown.types";

export const findSelectedLabel = (
  options: readonly SearchableDropdownOption[],
  value?: string,
): string => options.find((option) => option.value === value)?.label ?? "";

export const getSelectedLabels = (
  options: readonly SearchableDropdownOption[],
  selectedValues: readonly string[],
): string[] =>
  selectedValues
    .map((value) => options.find((option) => option.value === value)?.label)
    .filter((label): label is string => Boolean(label));

export const buildMultiSelectDisplay = (
  options: readonly SearchableDropdownOption[],
  selectedValues: readonly string[],
): {
  displayLabel: string;
  extraCount: number;
  fullLabel: string;
  labels: string[];
} => {
  if (selectedValues.length === 0) {
    return { displayLabel: "", extraCount: 0, fullLabel: "", labels: [] };
  }
  const labels = getSelectedLabels(options, selectedValues);
  const displayLabels = labels.slice(0, 2);
  const extraCount = Math.max(labels.length - displayLabels.length, 0);
  return {
    displayLabel: displayLabels.join(", "),
    extraCount,
    fullLabel: labels.join(", "),
    labels,
  };
};

export const splitLabels = (
  labels: readonly string[],
): [string[], string[]] => {
  if (labels.length <= 6) return [[...labels], []];
  const mid = Math.ceil(labels.length / 2);
  return [labels.slice(0, mid), labels.slice(mid)];
};
